import { default as callToAction } from "./components/call-to-action";
import { default as carousel } from "./components/carousel";
import { default as modal } from "./triggers/trigger-modal";
import { default as tabs } from "./components/tabs";
import { default as toggleLayout } from "./components/toggle-layout";
import { default as toggleVisibility } from "./triggers/trigger-toggle";
import { default as video } from "./components/video";

callToAction();
carousel();
modal();
tabs();
toggleLayout();
toggleVisibility();
video();
